import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "app-multiple-input"
};
const _hoisted_2 = {
  class: "input-control"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加");

import { computed } from 'vue';
export default {
  name: 'multiple-input',
  props: {
    modelValue: {
      type: Array,
      default: () => [{
        name: '',
        link: ''
      }]
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const inputData = {
      name: '',
      link: ''
    };
    const inputList = computed(() => {
      if (props.modelValue.length === 0) {
        return [_objectSpread({}, inputData)];
      }

      return props.modelValue;
    });

    function addHandle() {
      let list = [...inputList.value];
      list.push(_objectSpread({}, inputData));
      emits('update:modelValue', list);
    }

    function deleteHandle(index) {
      let list = [...inputList.value];
      list.splice(index, 1).filter(Boolean);
      emits('update:modelValue', list);
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled");

      const _component_el_icon = _resolveComponent("el-icon");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inputList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [_createVNode(_component_el_input, {
          modelValue: item.name,
          "onUpdate:modelValue": $event => item.name = $event,
          placeholder: "请输入视频资料名称",
          class: "input-name"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_input, {
          modelValue: item.link,
          "onUpdate:modelValue": $event => item.link = $event,
          placeholder: "请输入视频资料链接",
          class: "input-link"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("div", _hoisted_2, [index === 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          size: "normal",
          onClick: addHandle
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : _createCommentVNode("", true), index > 0 ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "#f56c6c",
          size: "24px",
          onClick: $event => deleteHandle(index)
        }, {
          default: _withCtx(() => [_createVNode(_component_CircleCloseFilled)]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])]);
      }), 128))]);
    };
  }

};